import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorDetailsResponse } from '../model/http-error-details-response.model';
import { NotificationsService } from '../services/notifications.service';

@Injectable()
export class NotAcceptableInterceptor implements HttpInterceptor {
  constructor(private readonly notificationsService: NotificationsService) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(request: HttpRequest<any>, next: HttpHandler) {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 406) {
          const message = this.get406Message(error);

          if (message) {
            this.notificationsService.notifyInfoMessage(message);
          } else {
            this.notificationsService.notifyInfo('platform.errors.not-acceptable');
          }
        }

        return throwError(() => error);
      }),
    );
  }

  private get406Message(error: HttpErrorResponse): string | null {
    if (typeof error.error === 'string' && error.error.trim()) {
      return error.error;
    }

    if (error.error && typeof error.error === 'object') {
      const details = error.error as Partial<HttpErrorDetailsResponse> & { message?: string };
      return details.error_description || details.message || details.error || null;
    }

    return null;
  }
}